import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.jsx";
import Add from "@material-ui/icons/Add";
import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";
import { hist } from "../../index";

function HeaderLinks(props) {
  const { classes } = props;
  const openAddAdminForm = () => {
    hist.push("/admin/manage-admin/add");
  };

  return (
    <div className="header_main_links">
      <div className="new_Card">
        <Button
          color="iseas"
          round
          className={classes.marginRight}
          onClick={openAddAdminForm}
        >
          <Add className={classes.icons} /> Add
        </Button>
      </div>
    </div>
  );
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool,
};

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/ManageAdminHeader.js